import { RoleType, SearchType, SortDirection } from '../../../services/types/ApiTypes';
import { RoleListSearchParams } from './RolesListReducer';

export const DEFAULT_RESTRICTION = 'GeneralSearch';

export const createRequest = (searchValue = '', sortColumn = 'RoleName', page = 1, count = 15): RoleListSearchParams => ({
    PagingOptions: {
        Count: count,
        Page: page,
    },
    Restrictions:
        searchValue && searchValue.length > 0
            ? [
                  {
                      Field: '',
                      FieldSearchType: SearchType.NotSelected,
                      Value: searchValue || null,
                      Values: null,
                  },
              ]
            : [],
    SortItems: [
        {
            SortColumn: sortColumn,
            SortDirection: SortDirection.Asc,
        },
    ],
});

export const ROLE_TYPES = {
    [RoleType.Predefined]: 'views.roles.RoleType.PredefinedRole',
    [RoleType.Custom]: 'views.roles.RoleType.CustomRole',
};

export const getRoleTypeLabel = (type: RoleType) => {
    return ROLE_TYPES[type];
};
